import {create} from 'zustand';
import {persist} from 'zustand/middleware';

export interface LoginStore {
  isLoggedIn: boolean;
  userdata: any;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  setUserData: (userdata: any) => void;
}

const useLoginStore = create<LoginStore>()(
  persist(
    set => ({
      isLoggedIn: false,
      userdata: undefined,
      setIsLoggedIn: (isLoggedIn: boolean) => {
        set({isLoggedIn});
      },
      setUserData: (userdata: any) => {
        set({userdata});
      },
    }),
    {
      name: 'login-state',
    },
  ),
);

export default useLoginStore;
